/* Benebone mega nav — open/close behavior (desktop) */
(function () {
  var items = Array.prototype.slice.call(document.querySelectorAll('[data-bmn-item]'));
  if (!items.length) return;

  function closeAll(except) {
    items.forEach(function (item) {
      if (item === except) return;
      var trigger = item.querySelector('.bmn__trigger');
      var dropdown = item.querySelector('.bmn__dropdown');
      trigger.setAttribute('aria-expanded', 'false');
      dropdown.hidden = true;
    });
  }

  items.forEach(function (item) {
    var trigger = item.querySelector('.bmn__trigger');
    var dropdown = item.querySelector('.bmn__dropdown');

    function open() {
      closeAll(item);
      trigger.setAttribute('aria-expanded', 'true');
      dropdown.hidden = false;
    }

    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('focus', open);
    trigger.addEventListener('click', open);
    // Keep open while hovering the dropdown itself
    dropdown.addEventListener('mouseenter', function () {
      trigger.setAttribute('aria-expanded', 'true');
      dropdown.hidden = false;
    });
  });

  // Close when the pointer leaves the whole header area
  var header = document.querySelector('.header-wrapper') || document.querySelector('header');
  if (header) {
    header.addEventListener('mouseleave', function () { closeAll(null); });
  }

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });

  // Close when clicking outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-bmn-item]')) closeAll(null);
  });
})();

/* Benebone mobile drill-in menu */
(function () {
  var nav = document.querySelector('.bmnm');
  if (!nav) return;

  var toggle = nav.querySelector('.bmnm__toggle');
  var panel = nav.querySelector('.bmnm__panel');
  var iconOpen = nav.querySelector('.bmnm__icon-open');
  var iconClose = nav.querySelector('.bmnm__icon-close');
  var views = Array.prototype.slice.call(nav.querySelectorAll('[data-bmnm-view]'));

  function showView(name, dir) {
    views.forEach(function (v) {
      var match = v.getAttribute('data-bmnm-view') === name;
      v.hidden = !match;
      v.classList.remove('bmnm__view--anim-left', 'bmnm__view--anim-right');
      if (match && dir) {
        // restart animation
        void v.offsetWidth;
        v.classList.add(dir === 'left' ? 'bmnm__view--anim-left' : 'bmnm__view--anim-right');
      }
    });
    panel.scrollTop = 0;
  }

  function setOpen(open) {
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    iconOpen.hidden = open;
    iconClose.hidden = !open;
    if (open) {
      showView('root', null);
      startAutoScroll();
    } else {
      cancelAnimationFrame(favsRaf);
    }
  }

  toggle.addEventListener('click', function () {
    setOpen(panel.hidden);
  });

  nav.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-bmnm-open]');
    if (opener) {
      showView(opener.getAttribute('data-bmnm-open'), 'right');
      return;
    }
    if (e.target.closest('[data-bmnm-back]')) {
      showView('root', 'left');
      startAutoScroll();
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) setOpen(false);
  });

  // Favorites slider: shuffle once per page load, duplicate the set for a
  // seamless infinite loop, and auto-scroll until the user touches it
  // (matches prototype behavior).
  var favs = nav.querySelector('[data-bmnm-favs]');
  var favsRaf = 0;
  var favsStopped = false;

  if (favs) {
    var tiles = Array.prototype.slice.call(favs.children);
    tiles.sort(function () { return Math.random() - 0.5; });
    tiles.forEach(function (t) { favs.appendChild(t); });
    // Duplicate the set so the loop can wrap seamlessly
    tiles.forEach(function (t) {
      var clone = t.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      favs.appendChild(clone);
    });

    // Wrap scroll position when passing the end of the first set
    favs.addEventListener('scroll', function () {
      var kids = favs.children;
      var setSize = kids.length / 2;
      if (setSize < 1) return;
      var period = kids[setSize].offsetLeft - kids[0].offsetLeft;
      if (period <= 0) return;
      if (favs.scrollLeft >= period) favs.scrollLeft -= period;
    });

    var stopAuto = function () {
      favsStopped = true;
      cancelAnimationFrame(favsRaf);
    };
    favs.addEventListener('touchstart', stopAuto, { passive: true });
    favs.addEventListener('mousedown', stopAuto);
    favs.addEventListener('wheel', stopAuto, { passive: true });
  }

  function startAutoScroll() {
    if (!favs || favsStopped) return;
    cancelAnimationFrame(favsRaf);
    var pos = favs.scrollLeft;
    var tick = function () {
      if (favsStopped || panel.hidden) return;
      if (Math.abs(favs.scrollLeft - pos) > 2) pos = favs.scrollLeft;
      pos += 0.12;
      favs.scrollLeft = pos;
      favsRaf = requestAnimationFrame(tick);
    };
    setTimeout(function () {
      favsRaf = requestAnimationFrame(tick);
    }, 800);
  }
})();
